import { isValid } from 'date-fns'

export class DateSegment {
  year: number = 1900
  month: number = 0 // 0 = January
  day: number = 1

  constructor(date?: Date)
  constructor(year: number, month: number, day: number)
  constructor(...args) {
    switch (args.length) {
      case 0:
        break // noop
      case 1:
        this.constructWithDate.apply(this, args)
        break
      case 3:
        this.constructWithNumbers.apply(this, args)
        break
      default:
        throw new Error('Invalid arguments')
    }
  }

  static fromDate(date: Date | null) {
    return date && isValid(date) ? new DateSegment(date) : null
  }

  static fromNumbers(year: number, month: number, day: number) {
    return new DateSegment(year, month, day)
  }

  constructWithDate(date: Date) {
    this.constructWithNumbers(date.getFullYear(), date.getMonth(), date.getDate())
  }

  constructWithNumbers(year: number, month: number, day: number) {
    this.year = year
    this.month = month
    this.day = day
  }

  toDate(referenceDate = new Date(0)) {
    return new Date(
      this.year,
      this.month,
      this.day,
      referenceDate.getHours(),
      referenceDate.getMinutes(),
      referenceDate.getSeconds(),
      referenceDate.getMilliseconds(),
    )
  }
}
